(function () {
	'use strict';
	$(document).ready(function () {

		if ($('.nhm').length) {
			function nhmSearch() {
				if ($('.nhm').length) {
					var searchPhrase = $('input[name="nhm-search-phrase"]').val();
					var searchMainCat = $('select[name="nhm-main-cat"]').val();
					var searchMainCatTitle = $('select[name="nhm-main-cat"]').find("option:selected").attr('title');

					var nonce = fhGetConfig('nonce');

					$.ajax({
						url: "/wp-admin/admin-ajax.php",
						method: "post",
						timeout: 10000,
						data: {
							action: "search_nhm",
							search_phrase: searchPhrase,
							search_main_cat: searchMainCat,
							search_main_cat_title: searchMainCatTitle,
							nonce: nonce,
						},
						success: function (data) {
							$('#nhm-content').append(data);
						},
						error: function () {
							$('.ajax-error').slideDown();
						},
						beforeSend: function () {
							$('#nhm-content').empty();
							$('.ajax-error').slideUp();
							$('.ajax-loading').slideDown();
						},
						complete: function () {
							$('.ajax-loading').slideUp();
						},
					});
				}
			}

			$('#nhm-form').on('submit', function (e) {
				e.preventDefault();
				nhmSearch();
			});

			if (window.matchMedia("(min-width: 768px)").matches) {
				var select = document.getElementById('nhm-main-cat');
				var options = select.getElementsByTagName('option');
				for (var i = 0; i < options.length; i++) {
					var text = options[i].textContent;
					if (text.length > 20) {
						options[i].textContent = text.substring(0, 80) + '...';
					}
				}
			}

		}

	});
}(jQuery));
